import React from 'react'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import BenefitsSlider from 'components/home/BenefitsSlider'
import { H4, fontWeights } from 'styles/typography'
import { white } from 'styles/colors'
import { media } from 'styles/media'

const Container = styled.div`
  background-color: #161b1f;
  text-align: center;
  padding-top: 12px;

  ${media.medium`
    padding-top: 16px;
  `};

  ${media.large`
    padding-top: 24px;
  `};
`

const Heading = styled(H4)`
  color: ${white};
  text-transform: uppercase;
  font-weight: ${fontWeights.regular};
  letter-spacing: 0.1em;

  &:before {
    content: '';
    display: block;
    width: 150px;
    height: 1px;
    background-color: ${white};
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;

    ${media.small`
      margin-bottom: 48px;
    `};

    ${media.medium`
      display: none
    `};
  }
`

const Why = () => (
  <Container>
    <Section>
      <Wrapper>
        <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
          Why shop online?
        </Heading>
      </Wrapper>
    </Section>
    <Section flushTop>
      <ScrollAnimation animateIn="fadeInUp" offset={0} delay={200} animateOnce>
        <BenefitsSlider />
      </ScrollAnimation>
    </Section>
  </Container>
)

export default Why
